export default "__VITE_ASSET__6b809be1__$_?react__"